<template>
    <v-checkbox
        v-bind="valueBind"
        :id="id"
        v-model="model"
        class="rtls-checkbox"
        :label="label"
        :disabled="isDisabled"
        :rules="rules"
        :hide-details="hideDetails || null"
        :indeterminate="indeterminate"
        :value="groupValue || value || undefined"
        :true-value="trueValue"
        :validate-on="validateOn"
        @click="$emit('click')"
    />
</template>

<script>
import vuexComponentMixin from '../../mixins/vuex-component';
import { isNil } from 'lodash';

export default {
    mixins: [vuexComponentMixin],

    props: {
        id: {
            type: String,
            default: undefined,
        },
        hideDetails: {
            type: Boolean,
            default: true,
        },
        value: {
            String,
            default: null,
        },
        groupValue: {
            type: String,
            default: null,
        },
        indeterminate: {
            Boolean,
            default: false,
        },
        trueValue: {
            default: undefined,
        },
        validateOn: {
            type: String,
            default: 'blur',
        },
    },
    emits: ['click'],
    computed: {
        valueBind() {
            if (isNil(this.value)) {
                return {};
            }

            return { modelValue: this.value };
        },
        isDisabled() {
            return this.disabled || this.isReadOnly;
        },
    },
};
</script>

<style></style>
